import React from 'react';
import PropTypes from 'prop-types';

const SelectContainer = ({ label, children }) => (
  <div className="select-container d-flex align-items-center">
    {label &&
      <span className="faux-label m-b-0 m-r-2">{label}</span>
    }
    {children}
  </div>
);

SelectContainer.propTypes = {
  label: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]).isRequired,
};

export default SelectContainer;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/SelectContainer.js